module.exports = __webpack_public_path__ + "img/02_1.228e40b4.png";